export const Projects = [
  {
    id: 1,
    name: "Fullstack Inventory Management System (React and Django)",
    img: require("../../assets/Web project/IMS.png").default,
    description:
      "An inventory Management System using ReactJS, django for backend and MySQLite for Database",
    link: "https://github.com/Gemack/Inventory-Management-System",
  },
  {
    id: 3,
    name: "Data Science Blog application with Django",
    img: require("../../assets/Web project/DSC.png").default,
    description: "A fullstack blog application using DJango",
    link: "https://github.com/Gemack/DS_connect-webapp-django",
  },
  {
    id: 2,
    name: "Event Planner UI",
    img: require("../../assets/Web project/event.jpg").default,
    description:
      "An Event Planner User Interface with HTML,CSS JavaScript and Jquery",
    preview: "https://practical-leakey-61ac87.netlify.app/",
    link: "https://github.com/Gemack/Event-planner-website",
  },
  {
    id: 18,
    name: "Dashboard with Power BI",
    img: require("../../assets/Web project/Viz.png").default,
    description: "Bueatiful visualization using Microsoft power bi",
    link: "https://github.com/Gemack/Data-analysis-and-viz-with-power-bi",
  },
  {
    id: 4,
    name: "frontend react and material ui",
    img: require("../../assets/Web project/Explore UI with React.jpg").default,
    description: "A User Interface with React and the Materia UI library",
    preview: "https://romantic-wright-2110ed.netlify.app/",
    link: "https://github.com/Gemack/Materia-UI-and-React",
  },
  {
    id: 5,
    name: "Explorative Data analysis",
    img: require("../../assets/Web project/Population.png").default,
    description: "Exploring Nigeria by region and population",
    link: "https://github.com/Gemack/Explorative-data-analysis-Nigeria-Area-Population",
  },
  {
    id: 7,
    name: "Ecommerce Fullstack",
    img: require("../../assets/Web project/Fullstack Ecommerce.jpg").default,
    description: "Fullstack Ecommerce with React, Express and Mongodb",
    link: "https://github.com/Gemack/React-ecommerce",
  },
  {
    id: 15,
    name: "Sentiment Analysis",
    img: require("../../assets/Web project/Sentiment.png").default,
    description:
      "This project uses Tfidfvectorizer in Sklearn to classify reviews in a book review into two category. Good or bad.",
    link: "https://github.com/Gemack/Sentiment-analysis-with-python-bag-of-words",
  },
  {
    id: 13,
    name: "NewGrid frontend",
    img: require("../../assets/Web project/blog.jpg").default,
    description: "A Newsgrid frontend design using just HTML and CSS",
    preview: "https://epic-saha-db68c9.netlify.app/",
    link: "https://github.com/Gemack/News-website",
  },
  {
    id: 6,
    name: "Buldozer sales prediction",
    img: require("../../assets/Web project/Bulldozer.png").default,
    description: "Buldozer Sales prediction using various regression models",
    link: "https://github.com/Gemack/Bulldozers-sale-regression-model",
  },

  {
    id: 8,
    name: "Heart Disease Machine Learning",
    img: require("../../assets/Web project/Heart disease.png").default,
    description: "Heart Disease Prediction using classification models",
    link: "https://github.com/Gemack/Heart-Disease-Classification-algorithm",
  },

  {
    id: 9,
    name: "Movie blog frontend",
    img: require("../../assets/Web project/movie-blog.jpg").default,
    description: "Frontend Movie blog post design with HTML and CSS ",
    preview: "https://kind-heyrovsky-a20076.netlify.app/",
    link: "https://github.com/Gemack/Movie-blog",
  },
  {
    id: 17,
    name: "Image Recognition",
    img: require("../../assets/Web project/Image rec.png").default,
    description: "Image Recognition using CNN",
    link: "https://github.com/Gemack/image-classification-with-tensorflow-and-opencv",
  },
  {
    id: 10,
    name: "DSN Hackaton",
    img: require("../../assets/Web project/DSN Hackaton.png").default,
    description: "Solution to 2021 DSN Hackaton ",
    link: "https://github.com/Gemack/Subscription-predicting-model",
  },
  {
    id: 11,
    name: "Online Shopping Cart (React)",
    img: require("../../assets/Web project/shopping cart.jpg").default,
    preview: "https://xenodochial-gates-91d60c.netlify.app",
    description:
      "An Online Shopping Cart using Context API and useReducer (Not 100% mobile friendly) ",
    link: "https://github.com/Gemack/Online-Sore",
  },
  {
    id: 16,
    name: "Stock price Analysis and Prediction",
    img: require("../../assets/Web project/stock price.png").default,
    description:
      "Stock Price Time Series Financial Analysis and Forecasting using Google Tensorflow (LSTM)",
    link: "https://github.com/Gemack/Financial-analysis-and-forecasting",
  },
];
